import CountryFlag from "react-country-flag";
import { GroupBase, ValueContainerProps, components } from "react-select";

import { Flex } from "@chakra-ui/layout";

import { SelectOptionInterface } from "@ts/interfaces/UI/UiInterface";

const CountryValueContainer = ({
    children,
    ...props
}: ValueContainerProps<
    SelectOptionInterface,
    false,
    GroupBase<SelectOptionInterface>
>) => {
    const [selected] = props.getValue();
    return (
        <Flex align="center" pl={4}>
            <CountryFlag
                countryCode={selected?.value}
                svg
                style={{ width: 20, height: "auto", marginRight: "-0.65rem" }}
            />
            <components.ValueContainer {...props}>
                {children}
            </components.ValueContainer>
        </Flex>
    );
};

export default CountryValueContainer;
